export default __webpack_public_path__ + "static/Toyota_Desktop_Typography_Subhead_Weight-6575f51c6d6ab114b10a8236c6b68cc4.svg";